module.exports = __webpack_public_path__ + "static/media/BDD_SetUpScreens_Mobility.ca54c2c4.png";